export default __webpack_public_path__ + "img/icon_instagram_link-944324912da2a152b40a9fb9fe32ee5a.png";